<div class="ngx-mat-tel-input-container gb-intl-phone-input-container">
  <button type="button" mat-button [matMenuTriggerFor]="menu" class="country-selector" [disabled]="disabled">
    <div class="flex-row-center">
      <span class="country-selector-flag flag" [ngClass]="selectedCountry.flagClass"></span>
      <span class="country-selector-code" *ngIf="selectedCountry?.dialCode">+{{ selectedCountry.dialCode }}</span>
      <span class="dropdown-icon"></span>
    </div>
  </button>
  <mat-menu #menu="matMenu">
    <input
      class="country-search"
      [(ngModel)]="searchCriteria"
      type="text"
      [placeholder]="searchPlaceholder"
      (click)="$event.stopPropagation()"
      id="search"
      #searchInput
    />
    <button
      type="button"
      mat-menu-item
      class="country-list-button"
      *ngFor="let country of preferredCountriesInDropDown | search: searchCriteria"
      (click)="onCountrySelect(country)"
    >
      <div class="icon-wrapper">
        <div class="flag" [ngClass]="country.flagClass"></div>
      </div>
      <div class="label-wrapper">
        ({{ country.iso2.toUpperCase() }})
        <span *ngIf="country?.dialCode">+{{ country.dialCode }}</span>
      </div>
    </button>
    <mat-divider *ngIf="preferredCountriesInDropDown?.length"></mat-divider>
    <ng-container *ngFor="let country of allCountriesInDropDown | search: searchCriteria">
      <button
        type="button"
        mat-menu-item
        class="country-list-button"
        *ngIf="country"
        (click)="onCountrySelect(country)"
      >
        <div class="icon-wrapper">
          <div class="flag" [ngClass]="country.flagClass"></div>
        </div>
        <div class="label-wrapper">({{ country.iso2.toUpperCase() }}) +{{ country.dialCode }}</div>
      </button>
    </ng-container>
  </mat-menu>

  <input
    matInput
    type="tel"
    autocomplete="off"
    (blur)="onTouched()"
    (keypress)="onInputKeyPress($event)"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onPhoneNumberChange()"
    [errorStateMatcher]="errorStateMatcher"
    [disabled]="disabled"
    [aria-describedby]="describedBy"
    #matInput="matInput"
  />
</div>
